import {postFormData} from './utils';

const dao = {
  listDevices: tmp => postFormData('/smb/skincare/list-devices.action', tmp),
};

export default dao;
